// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2p-6";
export var headerCell = "_2p-2";
export var loadingStateContent = "_2p-8";
export var rowWrapper = "_2p-4";
export var stickyAggregationCell = "_2p-b";
export var stickyAggregationRow = "_2p-7";
export var stickyColumnCell = "_2p-a";
export var stickyColumnHeaderCell = "_2p-9";
export var table = "_2p-1";
export var virtualRowWrapper = "_2p-5";
export var virtualTableBodyFiller = "_2p-d";
export var virtualTableBodyFillerBottom = "_2p-e";
export var virtualTableContainer = "_2p-0";
export var virtualTableContainerFill = "_2p-c";
export var white = "_2p-3";